module.exports = __webpack_public_path__ + "static/media/error-green.c9c675b6.png";